import RemoteCollection from "#root/utility/remote-collection";
import { z } from "zod";

export const BillingInvoiceListItemsSchema = z.object({
  id: z.number(),
  date: z.string(),
  total: z
    .string()
    .nullish()
    .transform(() => "0.00"),
  paid: z
    .string()
    .nullish()
    .transform(() => "0.00"),
  pdfLink: z.string(),
  segment: z.string().nullish(),
  accountId: z.number().nullish(),
  accountName: z.string().nullish(),
  iifLink: z.string(),
});

export const BillingInvoiceDetailItemSchema = BillingInvoiceListItemsSchema.extend({
  invoice: z.string().nullish(),
  purchaseOrder: z.string().nullish(),
  note: z.string().nullish(),
  reference: z.string().nullish(),
}).loose();

export type BillingInvoiceListItem = z.output<typeof BillingInvoiceListItemsSchema>;
export type BillingInvoiceDetailItem = z.output<typeof BillingInvoiceDetailItemSchema>;

export const billingInvoiceCollection = new RemoteCollection("/api/invoice", BillingInvoiceListItemsSchema, BillingInvoiceDetailItemSchema);

export const InvoiceItemListItemSchema = z.object({
  id: z.number(),
  invoiceId: z.number(),
  description: z.string().nullish(),
  rate: z.string().nullish(),
  quantity: z.number().nullish(),
  interval: z.string().nullish(),
  productId: z.number().nullish(),
});

export const InvoiceItemDetailItemSchema = InvoiceItemListItemSchema.loose(); // All items are the same

export type InvoiceItemListItem = z.output<typeof InvoiceItemListItemSchema>;
export type InvoiceItemDetailItem = z.output<typeof InvoiceItemDetailItemSchema>;

export function getBillingInvoiceItemCollection(invoiceId: string) {
  return new RemoteCollection(`/api/invoice/${invoiceId}/item`, InvoiceItemListItemSchema, InvoiceItemDetailItemSchema);
}

export const AccountInvoiceListItemSchema = z.object({
  id: z.number(),
  date: z.string(),
  total: z.string().nullish(),
  paid: z.string().nullish(),
  pdfLink: z.string(),
});

export const AccountInvoiceDetailItemSchema = AccountInvoiceListItemSchema.loose(); // All items are the same

export function getInvoiceCollectionForAccount(accountId: string) {
  return new RemoteCollection("/api/account/" + accountId + "/invoice", AccountInvoiceListItemSchema, AccountInvoiceDetailItemSchema);
}
